export enum AirwayConstants {
  SET_ACTION = 'airway/SET_ACTION',
  SET_FLOW = 'airway/SET_FLOW',
  SET_FIO2 = 'airway/SET_FIO2',
  SET_VIA = 'airway/SET_VIA',
  SET_HUMIDITY = 'airway/SET_HUMIDITY',
  SET_ORAL_PHARYNGEAL_AIRWAY = 'airway/SET_ORAL_PHARYNGEAL_AIRWAY',
  SET_AIR_TEMPERATURE = 'airway/SET_AIR_TEMPERATURE',
  SET_AIR_TEMPERATURE_UNIT = 'airway/SET_AIR_TEMPERATURE_UNIT',
  SET_AIR_TEMPERATURE_UNIT_TEMP = 'airway/SET_AIR_TEMPERATURE_UNIT_TEMP',
  SET_AIRWAY_COMPLICATIONS = 'airway/SET_AIRWAY_COMPLICATIONS',
  SET_AIRWAY_COMPLICATIONS_PNNV = 'airway/SET_AIRWAY_COMPLICATIONS_PNNV',
  SET_VERIFICATION_METHOD = 'airway/SET_VERIFICATION_METHOD',
  SET_PRESSURE = 'airway/SET_PRESSURE',
  SET_INSPIRATORY_PRESSURE = 'airway/SET_INSPIRATORY_PRESSURE',
  SET_EXPIRATORY_PRESSURE = 'airway/SET_EXPIRATORY_PRESSURE',
  SET_RESPONSE = 'airway/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'airway/SET_RESPONSE_PNNV',
  SAVE_AIRWAY = 'airway/SAVE_AIRWAY',
  RESET_STATE = 'airway/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'airway/SET_ADD_TO_TIMELINE',
  SET_STATE = 'airway/SET_STATE',
  SET_DATE_TIME = 'airway/SET_DATE_TIME',
  SET_ASSESSED_BY = 'airway/SET_ASSESSED_BY',
  ON_SELECT_AIRWAY = 'airway/ON_SELECT_AIRWAY',
  SET_UPDATE_INPUT_ROWS = 'airway/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'airway/SET_DATE',
  SET_TIME = 'airway/SET_TIME',
  SET_ATTEMPTS = 'airway/SET_ATTEMPTS',
  SET_PROCEDURE_COMPLICATIONS = 'airway/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'airway/SET_AUTHORIZATION',
  SET_SUCCESSFUL_ATTEMPT = 'airway/SET_SUCCESSFUL_ATTEMPT',
  SET_PTA = 'airway/SET_PTA',
  SET_COMMENTS = 'airway/SET_COMMENTS',
  SET_SIZE = 'airway/SET_SIZE',
  SET_ROLE_PERFORMING = 'airway/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'airway/SET_ROLE_PERFORMING_PNNV',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'airway/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'airway/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_AIRWAY_DEFAULTS = 'airway/SET_AIRWAY_DEFAULTS',
  SET_REASONS_FOR_FAILURE = 'airway/SET_REASONS_FOR_FAILURE',
}
